const becomeSellerDe = {
	breadcrumbs: {
		home: 'Startseite',
		becomeSeller: 'Verkäufer werden'
	},
	hero: {
		title: 'Verkäufer werden',
		subtitle: 'Wachsen Sie mit Grameen Bazar und erreichen Sie Millionen von Kunden',
		cta: 'Jetzt starten'
	},
	stats: [
		{ value: '50.000+', label: 'Aktive Verkäufer' },
		{ value: '98%', label: 'Pünktliche Auszahlungen' },
		{ value: '300%', label: 'Durchschn. Umsatzwachstum' },
		{ value: '4,8/5', label: 'Zufriedenheit der Verkäufer' }
	],
	benefits: {
		title: 'Vorteile des Verkaufens',
		items: [
			{ title: 'Umsatz steigern', description: 'Erreichen Sie über 1 Mio. Kunden mit Ihren Produkten' },
			{ title: 'Mehr verdienen', description: 'Faire Provisionen und schnelle Auszahlungen' },
			{ title: '24/7 Support', description: 'Unser engagiertes Verkäuferteam ist immer für Sie da' },
			{ title: 'Sichere Transaktionen', description: 'Vollständig sicheres und transparentes Zahlungssystem' },
			{ title: 'Schnelle Einrichtung', description: 'Eröffnen Sie Ihren Shop innerhalb von 24 Stunden' },
			{ title: 'Verkaufsanalysen', description: 'Detaillierte Berichte und Umsatz-Tracking' }
		]
	},
	steps: {
		title: 'So starten Sie',
		stepNumbers: ['1', '2', '3'],
		items: [
			{ title: 'Registrierung', description: 'Registrieren Sie sich mit Ihren persönlichen und geschäftlichen Daten' },
			{ title: 'Verifizierung', description: 'Unser Team prüft Ihre Angaben und bestätigt innerhalb von 24 Stunden' },
			{ title: 'Verkaufen', description: 'Produkte hochladen und verkaufen' }
		]
	},
	cta: {
		title: 'Starten Sie Ihr digitales Geschäft heute',
		subtitle: 'Werden Sie Teil von Grameen Bazar und heben Sie Ihr Geschäft auf das nächste Level',
		button: 'Als Verkäufer beitreten'
	},
	transformDreams: {
		title: "Verwirkliche deine Träume mit Grameen Bazar",
		content: [
			"Stell dir vor, wie dein Geschäft aufblüht – nicht nur mit bekannten Gesichtern, sondern auch mit neuen Kunden aus jedem Dorf, die dich zum allerersten Mal entdecken. Bei Grameen Bazar werden deine Produkte zu einem festen Bestandteil des Alltags von Menschen, die noch nie zuvor in einem Marktplatz eingekauft haben.",
			"Unser starkes Marketing dringt tief in ländliche Gemeinden vor, bringt Nachbarn und Freunde zusammen, die lokale Verkäufer – wie dich – unterstützen wollen. Unsere neueste Umfrage hat etwas Erstaunliches gezeigt: Fast 30% unserer Käufer sind zum ersten Mal Kunden eines Marktplatzes, bereit und voller Vorfreude, bei dir einzukaufen.",
			"Das ist eine Chance, die du noch nie hattest – Menschen zu erreichen, die bisher unerreichbar waren; sie in deine Geschichte einzuladen und deinen Umsatz um 50% bis 100% oder mehr zu steigern. Tritt Grameen Bazar bei – nicht nur als Plattform, sondern als Bewegung.",
			"Lass uns gemeinsam Hoffnung, Chancen und Wohlstand zu deiner Familie, deinem Dorf und deinen Träumen bringen. Die Kunden warten schon – jetzt ist es Zeit."
		]
	}
};

export default becomeSellerDe;


